export default __webpack_public_path__ + "static/media/DSC02225.b37634e2.jpeg";